import PageContainer, { PageHeader } from "@/components/PageContainer";
import { LEVELS_OF_CARE, ASAM_DIMENSIONS } from "@/data/content";

export default function LevelsOfCare() {
  return (
    <PageContainer testid="levels-page">
      <PageHeader
        overline="Part III · Levels of Care"
        title="From NARR Level I recovery housing through ASAM 4.0 medically managed inpatient."
        subtitle="Movement between levels is governed by ASAM Dimensional Admission and Transition Criteria (Dimensions 1–6, 4th edition)."
      />

      <div className="card overflow-hidden mb-14" data-testid="levels-table">
        <table className="w-full text-sm">
          <thead className="bg-cream">
            <tr className="text-left text-ink-muted">
              <th className="p-4 font-medium">Segment</th>
              <th className="p-4 font-medium">Levels</th>
              <th className="p-4 font-medium hidden md:table-cell">Setting</th>
              <th className="p-4 font-medium hidden md:table-cell">Typical LOS</th>
              <th className="p-4 font-medium hidden lg:table-cell">Primary clinical mission</th>
            </tr>
          </thead>
          <tbody>
            {LEVELS_OF_CARE.map((l, i) => (
              <tr
                key={l.id}
                className={i > 0 ? "border-t border-line-soft" : ""}
                data-testid={`level-row-${l.id}`}
              >
                <td className="p-4 text-navy font-medium">{l.segment}</td>
                <td className="p-4 text-ink">{l.levels}</td>
                <td className="p-4 text-ink-muted hidden md:table-cell">{l.setting}</td>
                <td className="p-4 text-ink-muted hidden md:table-cell">{l.los}</td>
                <td className="p-4 text-ink-muted hidden lg:table-cell">{l.mission}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <section data-testid="asam-dimensions">
        <div className="overline mb-2">Six ASAM Dimensions</div>
        <h2 className="text-navy text-2xl font-semibold tracking-tightest mb-5">
          Every intake, review, and discharge routes through these six.
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {ASAM_DIMENSIONS.map((d) => (
            <article key={d.n} className="card p-6" data-testid={`asam-dim-${d.n}`}>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 rounded-full bg-teal text-cream font-semibold flex items-center justify-center flex-shrink-0">
                  {d.n}
                </div>
                <div>
                  <h3 className="text-navy font-semibold mb-1.5">{d.title}</h3>
                  <p className="text-sm text-ink leading-relaxed">{d.detail}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </PageContainer>
  );
}
